import React from 'react'
import BreadGptMark from './BreadGptMark'

interface LogoProps {
  className?: string
  showText?: boolean
  textClassName?: string
  logoClassName?: string
  size?: number
}

const Logo: React.FC<LogoProps> = ({
  className = '',
  showText = true,
  textClassName = '',
  logoClassName = '',
  size = 40,
}) => {
  return (
    <div className={`logo-container ${className}`}>
      <BreadGptMark size={size} className={logoClassName} />
      {showText && (
        <h1 className={`logo-title ${textClassName}`}>
          Bread<span className="logo-title-accent">GPT</span>
        </h1>
      )}
    </div>
  )
}

export default Logo
